import { Box, Card, CardContent, Skeleton } from "@mui/material";
import { Masonry } from "@mui/lab";

const OrganizationSkeletonLoader = () => {
  const skeletonArray = Array.from({ length: 9 });

  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 4 }}>
      <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={2}>
        {skeletonArray.map((_, index) => (
          <Card
            key={index}
            sx={{
              borderRadius: 3,
              boxShadow: 2,
              height: 200, // Match card height
              backgroundColor: "#fff",
            }}
          >
            <CardContent>
              <Skeleton variant="text" height={28} width="60%" sx={{ mb: 1 }} />
              <Skeleton variant="text" height={20} width="80%" sx={{ mb: 2 }} />
              <Skeleton variant="text" height={20} width="90%" sx={{ mb: 1 }} />
              <Skeleton variant="text" height={20} width="70%" sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={24} width="40%" sx={{ mt: 2, borderRadius: 1 }} />
              <Skeleton variant="text" height={16} width="50%" sx={{ mt: 3 }} />
            </CardContent>
          </Card>
        ))}
      </Masonry>
    </Box>
  );
};

export default OrganizationSkeletonLoader;
